<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">

  <div v-if="open">
    <v-overlay

    ></v-overlay>

    <v-navigation-drawer
        absolute class="drawer"
        permanent
        right
        width="900"
    >
      <v-content class="view">
        <!--<v-card>-->
        <v-btn v-if="customer.code && this.customers.length > 1" :disabled="this.customers.length < 2"
               class="btn-previous d-none d-md-inline" color="primary" fab fixed left outlined small
               top
               @click="previous()">
          <v-icon>mdi-arrow-left</v-icon>
        </v-btn>
        <v-btn
            v-if="customer.code && this.customers.length > 1" :disabled="this.customers.length < 2"
            class="btn-next d-none d-md-inline" color="primary" fab fixed outlined right small
            top
            @click="next()">
          <v-icon>mdi-arrow-right</v-icon>
        </v-btn>


        <v-container v-if="activeTab==='Info'" fluid>
          <v-row>
            <v-col style="padding-left: 72px;padding-bottom: 0">

              <v-btn :loading="toggle_start_loading" class="mr-4" style="min-width: 20px;padding:0;position: relative"
                     text @click="ToggleStar()">
                <v-icon v-if="customer.stars && customer.stars.length >0" class="yellow--text"
                        large
                        style="position: absolute;top:0;left:0">
                  mdi-star
                </v-icon>
                <v-icon large>
                  mdi-star-outline
                </v-icon>
              </v-btn>

              {{ customer.nickname }}<br/>
              <TypeBadge :type="customer.type"></TypeBadge>
              {{ customer.code }}

            </v-col>
            <v-col class="d-none d-md-inline" style="padding-right: 72px;padding-bottom: 0">
              <div v-if="
                  customer.status == CustomerConst.STATUS_SUBMITTED_PENDING_SYNC ||
                  customer.status == CustomerConst.STATUS_SYNCED_PENDING_ACTIVE
                " class="headline text-right">
                สถานะลูกค้า: รออนุมัติ
              </div>

              <CreditBar v-else
                         :current="customer.debit_amount"
                         :fontSize="32"
                         :height="72"
                         :max="customer.credit_amount?customer.credit_amount:0"
                         :prop_blue="customer.debit_pending"
                         :prop_green="customer.debit_invoice"
                         :prop_red="customer.debit_overdue"
                         :width="400"
              ></CreditBar>

            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <div>
                <!--<v-card-title class="headline">-->

                <!--</v-card-title>-->
                {{ customer.name }}
              </div>
              <div>
                ที่อยู่: {{ customer.address }}<br/>
                {{ customer.district }}
                {{ customer.province }}
                {{ customer.zip_code }}<br/>
                <!--tax: {{customer.tax_no}}<br/>-->
                <!--email: {{customer.erp_email}}-->
              </div>
              <div class="title">โทร: {{ customer.erp_contract }} <a
                  :href="'tel:+66'+customer.erp_tel">{{ customer.erp_tel }}</a>
              </div>
            </v-col>
            <v-col class="text-right">
              <div>
                วงเงิน: ใช้แล้ว {{ customer.debit_amount }} บาท จาก {{ customer.credit_amount }} บาท<br/>
                <span v-if="customer.debit_pending>0">ค้างส่ง {{ customer.debit_pending }} บาท <br/></span>
                <span v-if="customer.debit_invoice>0" class="red--text">ค้างชำระ {{ customer.debit_invoice }} บาท <br/></span>

                เครดิต: {{ customer.credit_term }} วัน<br/>
                ธุรกิจ: {{ customer.business_type }}<br/>
                กลุ่มราคา: {{ customer.price_group ? PromotionGroupConst.map(customer.price_group.price_group) : '-' }}

              </div>
            </v-col>
          </v-row>
          <v-row>


          </v-row>
          <v-row>
            <v-col class="col-4">
              เซลล์
              <v-divider class="mb-2"></v-divider>
              <!--{{customer.cache_sales}}-->

              <Avatar v-for="sale in sales" v-bind:key="sale.id"
                      :active="sale.enabled"
                      :user="sale"
                      @click.native="openSales()"></Avatar>
              <v-avatar
                  v-if="!sales || sales.length===0"
                  color="grey"
                  size="64px"
                  @click="openSales()"
              >
                <v-icon x-large>mdi-plus</v-icon>
              </v-avatar>

            </v-col>
            <v-col>
              <v-card class="pa-2">
                <span class="caption">กราฟแสดงการสี่งซื้อ</span>
                <v-divider></v-divider>
                <v-sparkline
                    v-if="customer.id"
                    :auto-line-width="true"
                    :fill="false"
                    :gradient="['#42b3f4']"
                    :labels="graphData.labels"
                    :show-labels="true"
                    :smooth="false"
                    :value="graphData.values"
                    label-size="10"
                    type="bar"

                ></v-sparkline>

              </v-card>
              <v-textarea
                  v-model="customer.erp_remark1"
                  class="mb-1 mt-2"
                  height="86px"
                  hide-details
                  label="หมายเหตุ"
                  outlined
                  @keypress="isCommentChange=true"
              ></v-textarea>
              <v-row v-if="isCommentChange">

                <v-col>
                </v-col>
                <v-col class="col-2 text-right">
                  <v-btn

                      :loading="isLoadSetComment"
                      class="primary float-right" tile
                      @click="setComment()">
                    บันทึก
                  </v-btn>
                </v-col>
              </v-row>
              <v-row
                  v-if="!isCommentChange && [
                  UserConst.ROLE_ADMIN,
                  UserConst.ROLE_CEO,
                  UserConst.ROLE_DIRECTOR,
                  UserConst.ROLE_MANAGER,
                  UserConst.ROLE_ACCOUNT,
                  UserConst.ROLE_MARKETING].includes($store.state.$user.role)
              && customer.status===CustomerConst.STATUS_SYNCED_PENDING_ACTIVE">
                <v-col>
                </v-col>
                <v-col class="col-2 text-right">
                  <v-btn :loading="isLoadSetStatus" class="error" tile @click="RejectCustomer()">
                    ไม่อนุมัติ
                  </v-btn>
                </v-col>
                <v-col class="col-2 text-right">
                  <v-btn :loading="isLoadSetStatus" class="disabled" tile @click="ApproveCustomer()">
                    อนุมัติ
                  </v-btn>
                </v-col>
              </v-row>

            </v-col>
          </v-row>


        </v-container>

        <v-container v-if="activeTab==='Address'">
          <v-row>
            <v-col style="padding-left: 72px;padding-bottom: 0">
              <v-icon class="mr-4" large>mdi-star-outline</v-icon>
              {{ customer.nickname }}<br/>
              <TypeBadge :type="customer.type"></TypeBadge>
              {{ customer.code }}
            </v-col>
            <v-col style="padding-right: 72px;padding-bottom: 0">
              <v-text-field class="search"
                            hide-details="true"
                            label="ค้นหา"
                            outlined
                            placeholder="ใส่คำค้นหา"
                            small
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col>


              <v-content>

                <v-container
                    child-flex
                    class="container"
                    fluid
                >

                  <v-data-table
                      v-if="addresses && Array.isArray(addresses)"
                      :footer-props="{
                        'disable-items-per-page':true
                      }"
                      :headers="[
                        { text: 'รูป', value: 'default_image_thumbnail'},
                        { text: 'เลขที่',  value: 'name_address' },
                        { text: 'ตำบล', value: 'district.name'},
                        { text: 'อำเภอ', value: 'city.name' },
                        { text: 'จังหวัด', value: 'province.name' },

                        { text: 'map', value: 'map' },
                        { text: 'แก้ไข', value: 'edit' ,align:'right'},
                      ]"
                      :items="addresses"
                      :loading="this.tabs_address.isLoad"
                      class="elevation-1 tr-clickable"
                      disable-pagination
                      hide-default-footer

                      @click:row="(item,debug)=>openAddress({address:item,addresses:addresses,debug:debug})"
                  >
                    <template v-slot:item.default_image_thumbnail="{ item }">
                     <v-img  width="80"
                             class="grey lighten-2" :src="item.default_image_thumbnail"
                            @click.stop="openImageGallery([item.default_image_path,...item.medias.map(media=>media.content)].filter((value, index, array)=>array.indexOf(value) === index))"
                     ></v-img>
                    </template>

                    <template v-slot:item.name_address="{ item }">
                      {{ item.name }} <br/>{{ item.address }}
                    </template>

                    <template v-slot:item.gis_is_confirm="{ item }">
                      {{ item.gis_is_confirm ? '/' : '-' }}
                    </template>

                    <template v-slot:item.total_net="{ item }">
                      {{ number_format(item.total_net) }}
                    </template>
                    <template v-slot:item.edit="{ item }">
                      <v-btn right tile>
                        แก้ไข
                      </v-btn>
                    </template>
                    <template v-slot:item.map="{ item }">
                      <a :href="item.cache_lat>0?`https://maps.google.com/?q=${item.cache_lat},${item.cache_lng}`:'#'"
                         :target="item.cache_lat>0?'_blank':'_self'"
                         style="text-decoration: none">
                        <v-icon :color="item.gis_is_confirm?'green':'gray'"
                                large
                        >mdi-map
                        </v-icon>
                      </a>

                    </template>

                  </v-data-table>


                </v-container>


              </v-content>

              <v-btn
                  color="primary" fab fixed float
                  right

                  @click="addAddress()">
                เพิ่ม
              </v-btn>
            </v-col>
          </v-row>

        </v-container>


        <v-container v-if="activeTab==='Order'" fluid>
          <v-row>
            <v-col style="padding-left: 72px;padding-bottom: 0">
              <v-icon class="mr-4" large>mdi-star-outline</v-icon>
              {{ customer.nickname }}<br/>
              <TypeBadge :type="customer.type"></TypeBadge>
              {{ customer.code }}
            </v-col>
            <v-col style="padding-right: 72px;padding-bottom: 0">
              <v-text-field class="search"
                            hide-details="true"
                            label="ค้นหา"
                            outlined
                            placeholder="ใส่คำค้นหา"
                            small
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col>

              <div :style="{
                        paddingLeft:(8)+'px',
                        paddingRight:(8)+'px',

                     }"
                   class="list-header">
                <v-row
                    class="list-header-row">
                  <v-col>
                    <!--<v-btn outlined tile class="status-btn">รอ</v-btn>-->
                    <!--<v-btn outlined tile class="status-btn amber">ส่ง</v-btn>-->
                    <!--<v-btn outlined tile class="status-btn orange">บิล</v-btn>-->
                    <!--<v-btn outlined tile class="status-btn red">เลย</v-btn>-->
                    <!--<v-btn outlined tile class="status-btn grey">เสร็จ</v-btn>-->
                    <!--<v-btn outlined tile class="status-btn purple">ค้าง</v-btn>-->

                    <!--<v-btn v-if="false" v-for="{text,key,count} in filter.status.options" outlined tile-->
                    <!--:class="{-->
                    <!--'status-btn':true,-->
                    <!--'':key <= OrderConst.STATUS_ACCOUNT_CONFIRMED_WAIT_DO,-->
                    <!--'amber':key === OrderConst.STATUS_DO_CONFIRMED_WAIT_STOCK || key === OrderConst.STATUS_ON_DELIVERY,-->
                    <!--'orange':key === OrderConst.STATUS_INVOICED,-->
                    <!--'green':key === OrderConst.STATUS_PAID,-->
                    <!--'red':key === OrderConst.STATUS_OVERDUE,-->
                    <!--'grey':key === OrderConst.STATUS_TRANSACTION_CLEAR,-->
                    <!--'purple':key === OrderConst.STATUS_TRANSACTION_UNCLEAR,-->
                    <!--}"-->
                    <!--&gt;-->
                    <!--{{text}} ({{count}})-->
                    <!--</v-btn>-->
                  </v-col>
                  <v-col class="text-right caption">

                    <v-btn
                        class="title"
                        ourlined tile @click="isPickingDate=!isPickingDate">
                      {{ dateFrom }} - {{ dateTo }}
                    </v-btn>
                    <br/>
                    ปุ่มลัด:
                    <a href="#" @click="setDateLastMonth()">เดือนก่อน</a> &nbsp;
                    <a href="#" @click="setDateThisMonth()">เดือนนี้</a> &nbsp;
                    <a class="" href="#" @click="setDateToday()">วันนี้</a>
                  </v-col>
                </v-row>
                <v-row v-if="isPickingDate"
                       class="list-header-row">

                  <v-col class="text-right">
                    <v-date-picker

                        v-model="dateFrom"
                        locale="th"
                    ></v-date-picker>
                    <v-date-picker

                        v-model="dateTo"
                        locale="th"
                    ></v-date-picker>
                  </v-col>
                </v-row>

              </div>


              <v-content>

                <v-container
                    v-if="orders && orders.length>0"
                    child-flex
                    class="fill-height container pb-12"
                    fluid
                >

                  <v-data-table
                      v-if="orders && Array.isArray(orders)"
                      :headers="[
                        {
                          text: 'วันที่',
                          value: 'created_at',
                        },
                        { text: 'เลขที่', value: 'code' },
                        { text: 'ยอด in.vat', value: 'total_net',align:  'end'},
                        { text: 'สถานะ', value: 'status' },
                      ]"
                      :items="orders"
                      :loading="this.tabs_order.isLoad"
                      class="elevation-1 tr-clickable"
                      @click:row="(item,debug)=>openOrder({order:item,orders:orders,debug:debug})"
                  >

                    <template v-slot:item.created_at="{ item }">
                      {{ parseDate(item.submitted_at ? item.submitted_at : item.created_at) }}
                    </template>
                    <template v-slot:item.code="{ item }">
                      #{{ item.code }}
                    </template>

                    <template v-slot:item.total_net="{ item }">
                      {{ number_format(item.total_net) }}
                    </template>
                    <template v-slot:item.status="{ item }">
                      <v-btn :color="getStatusColor(item.status)" style="width:100%" tile>
                        {{ getStatusText(item.status) }}
                      </v-btn>
                    </template>
                  </v-data-table>

                </v-container>
              </v-content>


            </v-col>
          </v-row>

        </v-container>


        <v-container v-if="activeTab==='Loyalty'" fluid>
          <v-row>
            <v-col style="padding-left: 72px;padding-bottom: 0">
              <v-icon class="mr-4" large>mdi-star-outline</v-icon>
              {{ customer.nickname }}<br/>
              <TypeBadge :type="customer.type"></TypeBadge>
              {{ customer.code }}
            </v-col>
            <v-col style="padding-right: 72px;padding-bottom: 0">
              <div class="text-right">
                <div class="title">
                  คะแนนคงเหลือ: {{ number_format(customer.loyalty_balance || 0, 2) }}
                  <v-btn
                    class="ml-2 primary"
                    small
                    :disabled="!customer.loyalty_balance || customer.loyalty_balance <= 0"
                    @click="createPointOrder()">
                    แลกแต้ม
                  </v-btn>
                </div>
                <div class="caption">รวมได้รับ: {{ number_format(customer.loyalty_earned || 0, 2) }} | ใช้ไป: {{ number_format(customer.loyalty_spent || 0, 2) }}</div>
              </div>
            </v-col>
          </v-row>
          <v-row>
            <v-col>

              <div :style="{
                        paddingLeft:(8)+'px',
                        paddingRight:(8)+'px',

                     }"
                   class="list-header">
                <v-row
                    class="list-header-row">
                  <v-col>
                    <!-- Transaction type filters -->
                  </v-col>
                  <v-col class="text-right caption">

                    <v-btn
                        class="title"
                        ourlined tile @click="isPickingDateLoyalty=!isPickingDateLoyalty">
                      {{ dateFromLoyalty }} - {{ dateToLoyalty }}
                    </v-btn>
                    <br/>
                    ปุ่มลัด:
                    <a href="#" @click="setDateLastQuarterLoyalty()">ไตรมาสก่อน</a> &nbsp;
                    <a href="#" @click="setDateThisQuarterLoyalty()">ไตรมาสนี้</a> &nbsp;
                    <a class="" href="#" @click="setDateTodayLoyalty()">วันนี้</a>
                  </v-col>
                </v-row>
                <v-row v-if="isPickingDateLoyalty"
                       class="list-header-row">

                  <v-col class="text-right">
                    <v-date-picker

                        v-model="dateFromLoyalty"
                        locale="th"
                    ></v-date-picker>
                    <v-date-picker

                        v-model="dateToLoyalty"
                        locale="th"
                    ></v-date-picker>
                  </v-col>
                </v-row>

              </div>


              <v-content>

                <v-container
                    v-if="loyaltyTransactions && loyaltyTransactions.length>0"
                    child-flex
                    class="fill-height container pb-12"
                    fluid
                >

                  <v-data-table
                      v-if="loyaltyTransactions && Array.isArray(loyaltyTransactions)"
                      :headers="[
                        {
                          text: 'วันที่',
                          value: 'transaction_date',
                        },
                        { text: 'ประเภท', value: 'type' },
                        { text: 'รายละเอียด', value: 'subtype' },
                        { text: 'คะแนน', value: 'points', align: 'end'},
                        { text: 'คงเหลือ', value: 'balance', align: 'end'},
                      ]"
                      :items="loyaltyTransactions"
                      :loading="this.tabs_loyalty.isLoad"
                      class="elevation-1"
                  >

                    <template v-slot:item.transaction_date="{ item }">
                      {{ parseDate(item.transaction_date || item.created_at) }}
                    </template>
                    <template v-slot:item.type="{ item }">
                      <v-chip :color="item.type === 'earn' ? 'green' : 'red'" small text-color="white">
                        {{ item.type === 'earn' ? 'ได้รับ' : 'ใช้' }}
                      </v-chip>
                    </template>
                    <template v-slot:item.subtype="{ item }">
                      {{ item.subtype === 'percentage' ? 'แต้ม 5%' : item.subtype === 'commission' ? 'เยี่ยมลูกค้า' : item.subtype || '-' }}
                      <br/>
                      <span class="caption">{{ item.receipt_code || item.order_code || item.note || '-' }}</span>
                    </template>

                    <template v-slot:item.points="{ item }">
                      <span :class="item.type === 'earn' ? 'green--text' : 'red--text'">
                        {{ item.type === 'earn' ? '+' : '' }}{{ number_format(item.points, 2) }}
                      </span>
                    </template>
                    <template v-slot:item.balance="{ item }">
                      {{ item.type === 'earn' ? number_format(item.balance, 2) : '-' }}
                    </template>
                  </v-data-table>

                </v-container>

                <v-container v-else class="text-center pa-12">
                  <div class="title grey--text">ไม่มีรายการคะแนน</div>
                </v-container>
              </v-content>


            </v-col>
          </v-row>

        </v-container>


        <v-container v-if="activeTab==='Products'">
          <v-row>
            <v-col style="padding-left: 72px;padding-bottom: 0">
              <v-icon class="mr-4" large>mdi-star-outline</v-icon>
              {{ customer.nickname }}<br/>
              <TypeBadge :type="customer.type"></TypeBadge>
              {{ customer.code }}
            </v-col>
            <v-col style="padding-right: 72px;padding-bottom: 0">
              <v-text-field class="search"
                            hide-details="true"
                            label="ค้นหา"
                            outlined
                            placeholder="ใส่คำค้นหา"
                            small
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col>


              <v-content>
                <div style="text-align: right">
                  <a :href="'/api/reports/product_best_selling_by_customer/'+customer.id+'?token='+$helper.access_token()"
                     style="text-decoration: none" target="_blank">
                    แสดงทั้งหมด &gt;&gt;
                  </a>
                </div>
                <v-container
                    child-flex
                    class="container"
                    fluid
                >

                  <v-data-table
                      v-if="products && Array.isArray(products)"
                      :footer-props="{
                        'disable-items-per-page':true
                      }"
                      :headers="[
                        { text: 'รหัส', value: 'code'},
                        { text: 'สินค้า',  value: 'nickname' },
                        { text: 'จำนวน', value: 'quantity'},
                        { text: 'ราคาล่าสุด', value: 'last_price' },
                      ]"
                      :items="products"
                      :loading="this.tabs_products.isLoad"
                      class="elevation-1 tr-clickable"
                      disable-pagination
                      hide-default-footer

                  >
                    <template v-slot:item.quantity="{ item }">
                      {{ number_format(item.quantity,0) }}
                  </template>
                  </v-data-table>

                </v-container>


              </v-content>
            </v-col>
          </v-row>

        </v-container>


        <v-content v-if="activeTab==='Checkin'">
          <v-card-title class="headline">Customer</v-card-title>
          <v-card-text>Checkin</v-card-text>

        </v-content>


        <v-app-bar bottom fixed height="60">
          <!--<v-footer bottom>-->
          <!--<template v-slot:default>-->
          <v-tabs
              bottom
              center-active

              centered
              fixed
              height="60"
              slider-color="slider"
              slider-size="5"
          >

            <TabForDialog v-for="(tab, index) in tabs" :key="index" :tab="tab"></TabForDialog>
          </v-tabs>
          <!--</template>-->
        </v-app-bar>

        <v-btn bottom class="close-button" color="primary" fab fixed float right
               @click="()=>{this.close()}">
          <v-icon>mdi-close</v-icon>
        </v-btn>


        <!--</v-card>-->
        <!--</v-dialog>-->
      </v-content>
    </v-navigation-drawer>

  </div>
</template>
<style lang="scss" scoped>

.overlay {
  z-index: 5 !important;
}

.drawer {
  z-index: 6 !important;
}

.view {

  .v-card__title {
    padding-left: 68px;
    padding-right: 68px;
  }

  .v-app-bar {
    padding-right: 96px;
  }

  .list-row {
    position: relative;
    margin: 0;
  }

  .container {
    padding-top: 8px;
    width: 100%;
  }
}

.order-panel {
  margin-top: 1px;
  height: calc(100vh - 130px);
  position: relative;
  overflow: auto;

}

.btn-previous {

}

.btn-next {

}

.tab-item {
  min-height: 360px;
}

</style>

<script lang="ts">

import {Customer, CustomerConst} from '@/models/Customer'
import {CustomerAddress} from '@/models/CustomerAddress'
import {FilterOrder, Order, OrderConst} from '@/models/Order'
import {ProductTop} from '@/models/Product'
import {PromotionGroupConst} from '@/models/Promotion'
import {Truck} from '@/models/Truck'
import {User, UserConst} from '@/models/User'
import {Component, Vue, Watch} from 'vue-property-decorator'
import CreditBar from '../components/Customer/CreditBar.vue'
import TypeBadge from '../components/Customer/TypeBadge.vue'
import OrderRowInCustomer from '../components/Order/OrderRowInCustomer.vue'
import TabForDialog from '../components/TabForDialog.vue'
import Avatar from '../components/User/Avatar.vue'
import router from '../router'
import Helper from '../services/Helper.js'
import ViewOrder from '../views/ViewOrder.vue'

@Component({
  components: {
    Avatar,
    TypeBadge,
    OrderRowInCustomer,
    TabForDialog,
    ViewOrder,
    CreditBar,
  },
})
export default class CustomerDialog extends Vue {
  activeTab: string = 'Info'
  CustomerConst = CustomerConst
  PromotionGroupConst = PromotionGroupConst
  tabs_info = {
    name: 'ข้อมูล',
    click: () => this.click_tab('Info'),
    path: null,
    permissions: [],
    isLoad: false,
    badge: false,
  }
  tabs_order = {
    name: 'ออร์เดอร์',
    click: () => this.click_tab('Order'),
    path: null,
    permissions: [],
    isLoad: false,
    badge: false,
  }
  tabs_loyalty = {
    name: 'คะแนนสะสม',
    click: () => this.click_tab('Loyalty'),
    path: null,
    permissions: [],
    isLoad: false,
    badge: false,
  }
  tabs_address = {
    name: 'ที่อยู่ส่งของ',
    click: () => this.click_tab('Address'),
    path: null,
    permissions: [],
    isLoad: false,
    badge: false,
  }
  tabs_products = {
    name: 'สินค้า',
    click: () => this.click_tab('Products'),
    path: null,
    permissions: [],
    isLoad: false,
    badge: false,
  }
  tabs_checkin = {
    name: 'เช็คอิน',
    click: () => this.click_tab('Checkin'),
    path: null,
    permissions: [],
    isLoad: false,
    badge: false,
  }
  tabs_cart = {
    name: 'สั่งสินค้า',
    click: () => this.click_tab('Cart'),
    path: null,
    permissions: [],
    isLoad: false,
    badge: true,
    badge_number: 5,
  }

  tabs = [
    this.tabs_info,
    this.tabs_address,
    this.tabs_order,
    this.tabs_loyalty,
    this.tabs_products,
    // this.tabs_checkin,
    this.tabs_cart,
  ]

  dialog: boolean = false
  number_format = Helper.number_format
  isLoadCustomer = false
  isLoadOrders = false
  isLoadAddresses = false
  isLoadSetComment = false
  isCommentChange = false
  isLoadSetStatus = false
  UserConst = UserConst
  OrderConst = OrderConst
  isPickingDate = false
  dateFrom = new Date().toISOString().substr(0, 10)
  dateTo = new Date().toISOString().substr(0, 10)
  isPickingDateLoyalty = false
  dateFromLoyalty = new Date().toISOString().substr(0, 10)
  dateToLoyalty = new Date().toISOString().substr(0, 10)
  customer: Customer = new Customer()
  orders: Order[] | null = null
  products: ProductTop[] | null = null
  loyaltyTransactions: any[] | null = null
  addresses: CustomerAddress[] = []
  graphData = {labels: [' ', ' '], values: [0, 0]}
  sales: User[] | null = null
  filter = new FilterOrder()
  google_isLoad = false
  stat_isLoad = false
  toggle_start_loading: boolean = false
  confirmingLocation: boolean = false
  customers: Customer[] = []
  open = false
  index = 0


  getStatusColor(status) {
    return this.OrderConst.color(status)
  }

  getStatusText(status) {
    return this.OrderConst.map(status)
  }

  parseDate(dateStr) {
    const date = new Date(Date.parse(dateStr))
    return date.toLocaleString('th-TH', {
      weekday: 'short',
      year: '2-digit',
      month: 'short',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
    })

    // .toLocaleDateString('th-TH', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' })
  }

  async click_tab(name: string): Promise<void> {

    if (name == 'Cart') {
      if (
          this.customer.status == CustomerConst.STATUS_SUBMITTED_PENDING_SYNC ||
          this.customer.status == CustomerConst.STATUS_SYNCED_PENDING_ACTIVE

      ) {
        // alert("ลูกค้าไม่สามารถสั่งสินค้าได้ รอส่วนกลางอนุมัติบัญชี");
        this.$root.$emit('onWarning', {message: 'ลูกค้าไม่สามารถสั่งสินค้าได้ รอส่วนกลางอนุมัติบัญชี'})
        return
      }

      if (
          this.customer.status == CustomerConst.STATUS_REJECTED) {
        this.$root.$emit('onWarning', {message: 'ลูกค้าสถานะไม่อนุมัติ ไม่สามารถสั่งสินค้าได้'})
        return
      }

      if (
          this.customer.status == CustomerConst.STATUS_NOT_USE) {
        this.$root.$emit('onWarning', {message: 'ลูกค้าสถานะไม่ใช้แล้ว ไม่สามารถสั่งสินค้าได้'})
        return
      }


      if (
          this.customer.business_type == '') {
        this.$root.$emit('onWarning', {message: 'ลูกค้าไม่มีกลุ่มธุรกิจ ติดต่อฝ่ายบัญชี'})
        return
      }

      if (
          !this.customer.gis_is_confirm) {
        this.$root.$emit('onWarning', {message: 'ลูกค้าไม่ได้ยืนยันพิกัดไม่สามารถสั่งของได้'})
        return
      }


      // if (this.$store.state.$user.department!='TT' && this.sales && this.sales.length &&
      //     this.sales.length > 0 && this.sales.filter(s=>s.employee_code==this.$store.state.$user.employee_code).length==0) {
      //   this.$root.$emit('onWarning', {message: 'ลูกค้ามีเซลล์อยู่แล้ว'})
      //   return
      // }



      this.tabs_cart.isLoad = true
      var order = await this.$store.dispatch('init_cart', this.customer)//.then((cart: Order) => {
      this.tabs_cart.isLoad = false

      if(order instanceof Error){
        const e:Error = order
        this.$root.$emit('onError', {error: e})
        return
      }

      this.close()
      router.push('/cart')
      // })
      return
    }

    this.activeTab = name

    switch (name) {
      case 'Info':
        this.onTabInfo()
        break
      case 'Address':
        this.onTabAddress()
        break
      case 'Order':
        this.onTabOrder()
        break
      case 'Loyalty':
        this.onTabLoyalty()
        break
      case 'Products':
        this.onTabProducts()
        break
      case 'Checkin':
        this.onTabCheckin()
        break
    }

  }

  onOpen({id, customer, customers, index, debug, skip_load, onApply, activeTab}) {
    if (this.open) return
    console.log('Emited', {customer, customers, index, debug})

    if (activeTab) {
      this.activeTab = activeTab
    } else {
      this.activeTab = 'Info'
    }

    let tmpDateFrom = new Date()
    tmpDateFrom.setMonth(tmpDateFrom.getMonth() - 3)
    this.dateFrom = tmpDateFrom.toISOString().substr(0, 10)

    let tmpDateFromLoyalty = new Date()
    tmpDateFromLoyalty.setMonth(tmpDateFromLoyalty.getMonth() - 3)
    this.dateFromLoyalty = tmpDateFromLoyalty.toISOString().substr(0, 10)

    this.customer = new Customer()
    if (customer) {
      this.customer = customer
    } else if (id) {
      this.customer.id = id
    }
    if (index && customers) {
      this.index = index
      this.customers = customers
    } else {
      this.index = 0
      this.customers = []
    }

    this.open = true
    this.sales = []
    this.addresses = []
    this.onTabInfo()
  }

  mounted() {
    this.$root.$on('openCustomer', this.onOpen)
    console.log('customer dialog mounted')

  }

  previous() {
    if (this.customers.length > 1) {
      var index = (this.index - 1) % this.customers.length
      if(this.customers[index]) {
        this.index = index
        this.customer = this.customers[this.index]
        this.getCustomer()
        this.reloadCart()
      }
    }
  }

  next() {
    if (this.customers.length > 1) {
      var index = (this.index + 1) % this.customers.length
      if(this.customers[index]) {
        this.index = index
        this.customer = this.customers[this.index]
        this.getCustomer()
        this.reloadCart()
      }
    }
  }

  reloadCart() {
    const id: number = this.customer.id
    this.tabs_cart.badge = this.$store.state.carts.current_customer_map.hasOwnProperty(id)
    if (this.tabs_cart.badge) {
      const cart: Order = this.$store.state.carts.current_customer_map[id]
      this.tabs_cart.badge_number = cart.items.length
    }
  }

  async getCustomer() {
    this.tabs_info.isLoad = true

    this.customer = await Customer.prototype.load<Customer>(this.customer.id)


    this.getStat()


    this.tabs_info.isLoad = false


    // let sale1 = new User()
    // sale1.department = 'PJ'
    // sale1.nickname = 'น้องบาส'
    // sale1.picture = 'https://picsum.photos/120/120?image=120'
    //
    // let sale2 = new User()
    // sale2.department = 'TT'
    // sale2.nickname = 'พี่หนิง'
    // sale2.picture = 'https://picsum.photos/120/120?image=121'

    // this.customer.sales
    // state.users.id_map[user.id]

    this.refreshSale()


    // Helper.get(Helper.setting.customer.getResourceAPI.replace('{id}', id))
    //   .then<{ data: DataCustomer }>(({data}) => {
    //
    //     console.log(data.data)
    //     this.customer = data.data
    //     // this.items = data.data
    //     // console.log(this.items)
    //
    //     //this.$store.commit('customers_response', data)
    //     //this.reloadItem()
    //     this.tabs_info.isLoad = false
    //   })

  }

  async searchLocation() {

    if (this.customer) {

      if (this.customer.gis_type == CustomerConst.GIS_TYPE_USER) {
        if (!confirm('พิกัด confirm จากเซล์แล้ว ถ้ากด ok จะลบที่เซล์ตั้งไว้')) {
          return
        }
      }

      const id: number = this.customer.id
      this.google_isLoad = true

      this.customer = await Customer.prototype.search_location(id)

      this.google_isLoad = false


    }
  }

  async onConfirmLocation($event) {
    if (this.customer) {
      // this.customer.gis_is_confirm = $event

      this.confirmingLocation = true
      this.customer = await Customer.prototype.confirm_location(this.customer)
      this.confirmingLocation = false
    }
  }

  async editLocation() {
    this.$root.$emit('openLocationPicker', {
      option: {
        keyword: `${this.customer.name} ${this.customer.address} ${this.customer.district} ${this.customer.province} ${this.customer.zip_code}`
        , lat: this.customer.cache_lat, lng: this.customer.cache_lng,
      }, onApply: async (result) => {
        this.google_isLoad = true
        console.log('editLocation apply', result)

        this.customer.cache_lat = result.lat
        this.customer.cache_lng = result.lng

        try{
          this.customer = await Customer.prototype.save_location(this.customer)
        }catch (e){
          this.$root.$emit('onError', {error: e})
        }
        this.google_isLoad = false
      },
    })
  }

  async getStat() {

    const customer: Customer = Object.setPrototypeOf(this.customer, Customer.prototype)
    this.stat_isLoad = true
    console.log('gettingStat')
    const dataStat = await customer.loadStat()
    console.log('gettingStat', dataStat)
    this.graphData = dataStat
    console.log('graphData', this.graphData)
    //   {
    //   labels:
    //     ['กพ.', ' ', ' ', ' ', ' ', ' ', ' ', ' ', ' ', 'มีค.', ' ', ' ', ' ', ' ', ' '], values:
    //     [1, 2, 5, 9, 5, 10, 3, 5, 0, 0, 1, 8, 2, 9, 0],
    // }


    this.stat_isLoad = false

  }

  async getOrders() {

    const customer: Customer = Object.setPrototypeOf(this.customer, Customer.prototype)
    this.tabs_order.isLoad = true
    console.log('gettingOrders')
    const dataOrders = await customer.loadOrders()
    this.orders = dataOrders.data

    console.log('getOrders', this.orders)

    this.tabs_order.isLoad = false

    // Helper.get(Helper.setting.customer.getOrderAPI.replace('{id}', id))
    //   .then<{ data: DataOrdersArray }>(({data}) => {
    //
    //     console.log(data.data)
    //     this.orders = data.data
    //     // this.items = data.data
    //     // console.log(this.items)
    //
    //     //this.$store.commit('customers_response', data)
    //     //this.reloadItem()
    //     this.tabs_order.isLoad = false
    //   })

  }

  async getLoyaltyTransactions() {
    this.tabs_loyalty.isLoad = true
    console.log('gettingLoyaltyTransactions')

    try {
      const response = await Helper.get(`/api/loyalty/customer/${this.customer.id}/transactions?from=${this.dateFromLoyalty}&to=${this.dateToLoyalty}`)
      console.log('API Response:', response)

      // The API returns { success: true, data: { customer_id: X, transactions: [...] } }
      if (response.data && response.data.data && response.data.data.transactions) {
        this.loyaltyTransactions = response.data.data.transactions
      } else {
        this.loyaltyTransactions = []
      }

      console.log('getLoyaltyTransactions', this.loyaltyTransactions)
    } catch (e) {
      console.error('Failed to load loyalty transactions:', e)
      this.loyaltyTransactions = []
    }

    this.tabs_loyalty.isLoad = false
  }

  async getProducts() {

    const customer: Customer = Object.setPrototypeOf(this.customer, Customer.prototype)
    this.tabs_products.isLoad = true
    console.log('gettingProducts')
    const dataProducts = await customer.loadProducts()
    this.products = dataProducts.data

    console.log('getProducts', this.orders)

    this.tabs_products.isLoad = false

    // Helper.get(Helper.setting.customer.getOrderAPI.replace('{id}', id))
    //   .then<{ data: DataOrdersArray }>(({data}) => {
    //
    //     console.log(data.data)
    //     this.orders = data.data
    //     // this.items = data.data
    //     // console.log(this.items)
    //
    //     //this.$store.commit('customers_response', data)
    //     //this.reloadItem()
    //     this.tabs_order.isLoad = false
    //   })

  }
  async getAddresses() {

    const customer: Customer = Object.setPrototypeOf(this.customer, Customer.prototype)
    this.tabs_address.isLoad = true
    console.log('gettingAddresses')
    const dataAddresses = await customer.loadAddresses()
    this.addresses = dataAddresses.data

    console.log('getAddresses', this.addresses)

    this.tabs_address.isLoad = false
  }


  async ToggleStar() {
    const current_star = this.customer.stars && this.customer.stars.length > 0

    const customer: Customer = Object.setPrototypeOf(this.customer, Customer.prototype)
    this.toggle_start_loading = true
    await customer.SetStar(!current_star)
    this.toggle_start_loading = false
    if (current_star) {
      customer.stars.pop()
    } else {
      customer.stars.push({id: 0})
    }
  }

  ApproveCustomer() {
    this.$root.$emit('onWarning', {message: 'อนุมัติได้จาก ERP เท่านั้น'})
  }

  async RejectCustomer() {
    if (this.customer.erp_remark1 == null || this.customer.erp_remark1 == '') {
      this.$root.$emit('onWarning', {message: 'กรุณาใส่หมายเหตุ'})
      return
    }


    try {
      this.isLoadSetStatus = true
      await Object.setPrototypeOf({
        id: this.customer.id,
        mode: 'fill',
        status: CustomerConst.STATUS_REJECTED,
      }, Customer.prototype).save()
      this.customer.status = CustomerConst.STATUS_REJECTED
      this.isLoadSetStatus = false
    } catch (e) {
      this.$root.$emit('onError', {error: e})
    }
  }

  async setComment() {
    try {
      this.isLoadSetComment = true
      await Object.setPrototypeOf({
        id: this.customer.id,
        mode: 'fill',
        erp_remark1: this.customer.erp_remark1,
      }, Customer.prototype).save()
      this.isCommentChange = false
      this.isLoadSetComment = false
    } catch (e) {
      this.$root.$emit('onError', {error: e})
    }
  }

  openOrder(option) {
    this.$root.$emit('openOrder', option)
  }

  async saveAddress(cusAddress: CustomerAddress) {

    const isNew = cusAddress?.id === null

    cusAddress = Object.setPrototypeOf(cusAddress, CustomerAddress.prototype)

    if (cusAddress) {
      try {
        let object = await cusAddress.save<CustomerAddress>()
        this.$root.$emit('onSuccess', {message: 'บันทึกสำเร็จ'})
        if (isNew) {
          this.addresses.push(object)
        } else {
          for (let i in this.addresses) {
            if (this.addresses[i].id == object.id) {
              this.addresses[i] = object
            }
          }
        }
      }catch (e){
        this.$root.$emit('onError', {error: e})
      }

    }
  }

  async openAddress(option) {
    this.$root.$emit('openAddress', {
      ...option, onApply: this.saveAddress,
    })
  }


  addAddress() {
    let address = new CustomerAddress()
    address.customer_id = this.customer.id
    address.name = this.customer.name
    address.address = this.customer.address
    address.district = this.customer.district_obj
    address.district_id = this.customer.district_id
    address.city = this.customer.city_obj
    address.city_id = this.customer.city_id
    address.province = this.customer.province_obj
    address.province_id = this.customer.province_id
    address.zip_code = this.customer.zip_code
    address.contact_tel = this.customer.erp_tel
    address.cache_lat = this.customer.cache_lat
    address.cache_lng = this.customer.cache_lng
    this.$root.$emit('openAddress', {
      address: address, onApply: this.saveAddress,
    })
  }


  setDateLastMonth() {
    var tzoffset = (new Date()).getTimezoneOffset() * 60000
    // let tmpDateFrom = (new Date(Date.now() - tzoffset))
    var tmpDateFrom = new Date(Date.now())
    // tmpDateFrom.setMonth(tmpDateFrom.getMonth() - 1)
    tmpDateFrom.setDate(0)
    this.dateTo = (new Date(tmpDateFrom.getTime() - tzoffset)).toISOString().substr(0, 10)
    tmpDateFrom.setDate(1)
    this.dateFrom = (new Date(tmpDateFrom.getTime() - tzoffset)).toISOString().substr(0, 10)
    this.getOrders()
  }

  setDateThisMonth() {
    var tzoffset = (new Date()).getTimezoneOffset() * 60000
    var tmpDateFrom = new Date(Date.now())
    tmpDateFrom.setDate(1)
    this.dateFrom = (new Date(tmpDateFrom.getTime() - tzoffset)).toISOString().substr(0, 10)
    this.dateTo = (new Date(Date.now() - tzoffset)).toISOString().substr(0, 10)
    this.getOrders()
  }

  setDateToday() {
    var tzoffset = (new Date()).getTimezoneOffset() * 60000
    let tmpDateFrom = (new Date(Date.now() - tzoffset))

    this.dateFrom = tmpDateFrom.toISOString().substr(0, 10)
    this.dateTo = tmpDateFrom.toISOString().substr(0, 10)
    this.getOrders()
  }

  setDateLastQuarterLoyalty() {
    var tzoffset = (new Date()).getTimezoneOffset() * 60000
    var now = new Date(Date.now())
    var currentMonth = now.getMonth() // 0-11
    var currentYear = now.getFullYear()

    // Calculate last quarter
    var lastQuarterStartMonth = Math.floor(currentMonth / 3) * 3 - 3
    var lastQuarterEndMonth = lastQuarterStartMonth + 2
    var lastQuarterYear = currentYear

    if (lastQuarterStartMonth < 0) {
      lastQuarterStartMonth += 12
      lastQuarterEndMonth += 12
      lastQuarterYear -= 1
    }

    // Set start date to first day of quarter
    var tmpDateFrom = new Date(lastQuarterYear, lastQuarterStartMonth, 1)
    this.dateFromLoyalty = (new Date(tmpDateFrom.getTime() - tzoffset)).toISOString().substr(0, 10)

    // Set end date to last day of quarter
    var tmpDateTo = new Date(lastQuarterYear, lastQuarterEndMonth + 1, 0)
    this.dateToLoyalty = (new Date(tmpDateTo.getTime() - tzoffset)).toISOString().substr(0, 10)

    this.getLoyaltyTransactions()
  }

  setDateThisQuarterLoyalty() {
    var tzoffset = (new Date()).getTimezoneOffset() * 60000
    var now = new Date(Date.now())
    var currentMonth = now.getMonth() // 0-11
    var currentYear = now.getFullYear()

    // Calculate current quarter (Q1: 0-2, Q2: 3-5, Q3: 6-8, Q4: 9-11)
    var quarterStartMonth = Math.floor(currentMonth / 3) * 3

    // Set start date to first day of current quarter
    var tmpDateFrom = new Date(currentYear, quarterStartMonth, 1)
    this.dateFromLoyalty = (new Date(tmpDateFrom.getTime() - tzoffset)).toISOString().substr(0, 10)

    // Set end date to today
    this.dateToLoyalty = (new Date(Date.now() - tzoffset)).toISOString().substr(0, 10)

    this.getLoyaltyTransactions()
  }

  setDateTodayLoyalty() {
    var tzoffset = (new Date()).getTimezoneOffset() * 60000
    let tmpDateFrom = (new Date(Date.now() - tzoffset))

    this.dateFromLoyalty = tmpDateFrom.toISOString().substr(0, 10)
    this.dateToLoyalty = tmpDateFrom.toISOString().substr(0, 10)
    this.getLoyaltyTransactions()
  }

  close() {
    this.open = false
  }

  private onTabInfo() {
    this.getCustomer()
  }

  private onTabOrder() {
    this.getOrders()
  }

  private onTabLoyalty() {
    this.getLoyaltyTransactions()
  }

  async createPointOrder() {
    // Create a new cart with pay_by = 'point'
    try {
      const order = await this.$store.dispatch('init_cart', this.customer)

      // Set pay_by to 'point' and credit_term to 0 after cart is created
      order.pay_by = 'point'
      order.credit_term = 0
      await Object.setPrototypeOf({
        id: order.id,
        mode: 'fill',
        pay_by: 'point',
        credit_term: 0
      }, Order.prototype).save()

      this.close()
      router.push('/cart')
    } catch (e) {
      this.$root.$emit('onError', {error: e})
    }
  }

  private onTabAddress() {
    this.getAddresses()
  }

  private onTabProducts() {
    this.getProducts()
  }

  private onTabCheckin() {

  }

  private refreshSale() {
    this.sales = []
    console.log('customer sales', this.customer.sales)
    for (let index in this.customer.sales) {
      let sale = this.customer.sales[index]
      if (!sale || !sale.user_code) continue
      console.log('sales', sale)
      if (this.$store.state.users.code_map.hasOwnProperty(sale.user_code)) {
        let user = this.$store.state.users.code_map[sale.user_code]
        user.orderUser = sale
        this.sales.push(user)
      } else {
        let sale2 = new User()
        sale2.department = '??'
        sale2.nickname = sale.user_code
        sale2.picture = null
        sale2.orderUser = sale
        this.sales.push(sale2)
      }
    }
  }

  private openSales() {
    // debugger
    if (![
      UserConst.ROLE_ADMIN,
      UserConst.ROLE_CEO,
      UserConst.ROLE_DIRECTOR,
      UserConst.ROLE_MANAGER,
      UserConst.ROLE_ACCOUNT,
      UserConst.ROLE_MARKETING].includes(this.$store.state.$user.role)
    ) return


    this.$root.$emit('openSales', {
      sales: this.sales, onApply: async (sales) => {
        this.customer.sales = sales
        this.refreshSale()

        try {
          await Object.setPrototypeOf({
            id: this.customer.id,
            sales: sales,
          }, Customer.prototype).save()
        } catch (e) {
          this.$root.$emit('onError', {error: e})
        }
      },
    })
  }


  private async openImageGallery(imageList){
    this.$root.$emit('openImageGallery', {
      imageList: imageList
    })
  }

  @Watch('dateFromLoyalty')
  onDateFromLoyaltyChange() {
    if (this.activeTab === 'Loyalty' && this.customer.id) {
      this.getLoyaltyTransactions()
    }
  }

  @Watch('dateToLoyalty')
  onDateToLoyaltyChange() {
    if (this.activeTab === 'Loyalty' && this.customer.id) {
      this.getLoyaltyTransactions()
    }
  }
}

</script>
